var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cate-item" }, [
    _c("div", { staticClass: "cate-item__title" }, [
      _c("span", { staticClass: "cate-main-icon__span" }, [
        _c("i", { class: ["iconfont", _vm.icon || "icon-dianzizhengwu"] })
      ]),
      _vm._v(" "),
      _c("span", [_c("a", [_vm._v(_vm._s(_vm.text))])])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        class: ["cate-item__content", _vm.showCate ? "" : "cate-item__border"]
      },
      [
        _c(
          "ul",
          { staticClass: "second-cate" },
          _vm._l(_vm.children, function(item, index) {
            return _c("li", { key: index }, [
              _c(
                "a",
                { attrs: { href: "/search.html?fkCategoryId=" + item.id } },
                [_vm._v(_vm._s(item.text))]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "third-cate" },
                _vm._l(item.children, function(leaf, leafKey) {
                  return _c("li", { key: leafKey }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "/search.html?fkCategoryId=" + leaf.id }
                      },
                      [_vm._v(_vm._s(leaf.text))]
                    )
                  ])
                }),
                0
              )
            ])
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffa3f612", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffa3f612","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/nav-cate/cate-item.vue
// module id = fkbu
// module chunks = 1 2 3 4 5 6 7 8 9